import { Navigate, useLocation } from "react-router-dom";
import { getSavedToken, isTokenExpired } from "../utils/tokenHelper";

export default function ProtectedRoute({ children }) {
  const location = useLocation();
  const tokenData = getSavedToken();

  const isLoggedIn =
    localStorage.getItem("isLoggedIn") === "true" &&
    tokenData &&
    tokenData.access_token &&
    !isTokenExpired(tokenData);

  if (!isLoggedIn) return <Navigate to="/" replace />;

  const isNewUser = localStorage.getItem("isNewUser") === "true";

  // Profile incomplete hai to har protected route se profile-setup pe bhej do
  if (isNewUser && location.pathname !== "/profile-setup") {
    return <Navigate to="/profile-setup" replace />;
  }

  return children;
}